/*
 * @Author: your name
 * @Date: 2021-08-08 23:55:17
 * @LastEditTime: 2022-03-15 01:10:16
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /private-claim/src/router/index.js
 */
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Index",
    component: () =>
      import(/* webpackChunkName: "Retrieve" */ "../views/Policy/Retrieve.vue"),
    meta: {
      title: "请检索您的保单",
    },
  },
  {
    path: "/qa",
    name: "QA",
    component: () => import(/* webpackChunkName: "qa" */ "../views/Qa.vue"),
    meta: {
      title: "Q&A",
    },
  },
  {
    path: "/result",
    name: "Result",
    component: () =>
      import(/* webpackChunkName: "index" */ "../views/Index.vue"),
    meta: {
      title: "请选择产前检测结果",
    },
  },
  {
    path: "/highrisk/hint",
    name: "Hint",
    component: () =>
      import(/* webpackChunkName: "hint" */ "../views/HighRisk/Hint.vue"),
    meta: {
      title: "友情提示",
    },
  },
  {
    path: "/highrisk/instruction",
    name: "Instruction",
    component: () =>
      import(
        /* webpackChunkName: "instruction" */ "../views/HighRisk/Instruction.vue"
      ),
    meta: {
      title: "理赔须知",
    },
  },
  {
    path: "/lowrisk/type",
    name: "Type",
    component: () => import("../views/LowRisk/Type.vue"),

    meta: {
      title: "选择类型",
    },
  },
  {
    path: "/lowrisk/born",
    name: "Born",
    component: () => import("../views/LowRisk/Born.vue"),

    meta: {
      title: "理赔须知",
    },
  },
  {
    path: "/lowrisk/stop",
    name: "Stop",
    component: () => import("../views/LowRisk/Stop.vue"),

    meta: {
      title: "理赔须知",
    },
  },
  {
    path: "/mine/search",
    name: "Search",
    component: () => import("../views/Mine/Search.vue"),
    meta: {
      title: "我的理赔信息",
    },
  },
  // 我的
  {
    path: "/mine/status/:idStr",
    name: "Status",
    component: () => import("../views/Mine/Status.vue"),
    meta: {
      title: "我的理赔信息",
    },
  },
  // 理赔材料
  {
    path: "/claimMaterial/uploadFiles/:serNo/:t",
    name: "UploadFiles",
    component: () => import("../views/ClaimMaterial/UploadFiles.vue"),
    meta: {
      title: "理赔材料上传",
    },
  },
  {
    path: "/claimMaterial/uploadCards/:serNo",
    name: "UploadCards",
    component: () => import("../views/ClaimMaterial/UploadCards.vue"),
    meta: {
      title: "理赔材料上传",
    },
  },
  {
    path: "/claimMaterial/uploadBank/:serNo",
    name: "UploadBank",
    component: () => import("../views/ClaimMaterial/UploadBank.vue"),
    meta: {
      title: "理赔材料上传",
    },
  },
  {
    path: "/claimMaterial/uploadBasic/:t",
    name: "UploadBasic",
    component: () => import("../views/ClaimMaterial/UploadBasic.vue"),
    meta: {
      title: "理赔材料上传",
    },
  },
  {
    path: "/policy/retrieve",
    name: "Retrieve",
    component: () => import("../views/Policy/Retrieve.vue"),
    meta: {
      title: "请检索您的保单",
    },
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, form, next) => {
  document.title = to.meta.title;
  next();
});

export default router;
